<input type="file"
       style="display:none"
       #commercialInvoice
       (change)="handleImage($event)"
       accept=".png,.jpeg,.jpg,.tiff,.pdf,.gif" />
<div class="overlay {{lock? 'hidden':''}}">
  <div class="receipt open">
    <i class="armx-icon armx-cancel close-receipt" (click)="closeRecepit()"></i>
    <div class="col-md-12">
      <div class="recipt-scanner">
        <div class="recipt-scanner-header">
          <div class="row">
            <div class="col-md-1">
              <img src="/assets/icons/scanner.svg" style="max-width:50px;" />
            </div>
            <div class="col-md-11">
              <h4>{{ 'pages.createReceiptPage.commercialInvoice.scanInvoice' | translate }}</h4>
            </div>
          </div>
        </div>
        <div class="recipt-scanner-body">
          <div class="row">
            <div class="col-md-11 col-md-offset-1">
              <h5>{{ 'pages.createReceiptPage.commercialInvoice.uploadOrScanInvoice' | translate }}</h5>
              <div class="scanner-box">
                <span>{{ 'pages.createReceiptPage.formatsAllow' | translate }}</span>
                <div class="pull-right">
                  <!-- <select class="form-group" [(ngModel)]="scannerName">
      <option [ngValue]="-1">Select scanner</option>
      <option *ngFor="let scanner of scanners; i as index" [ngValue]="scanner" selected="{{i == 0}}">{{scanner}}</option>
    </select> -->
                  <button class="btn btn-scanner" (click)="scan()">
                    <span class="armx-icon armx-barcode"></span> {{ 'common.scan' | translate}}
                  </button>

                  <button class="btn btn-scanner" (click)="showWebcamModal = true">
                    <span class="armx-icon armx-camera"></span> {{ 'common.capture' | translate}}
                  </button>
                  <!-- <button class="btn btn-scanner" (click)="openCommercialInvoiceFile()">
      <span class="armx-icon armx-upload"></span> Upload
    </button> -->
                </div>
                <div id="dvamxscan"></div>
                <div class="row">
                  <div class="col-md-8 col-md-offset-1">
                    <webcam-modal *ngIf="showWebcamModal"
                                  (onImageCaptured)="handleWebcamCapturedImage($event)"
                                  (onModalClosed)="showWebcamModal = false"></webcam-modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-11 col-md-offset-1">
              <div class="form-group">
                <button (click)="addCommercialInvoice()"
                        class="btn btn-primary"
                        style="float:right">{{ 'common.done' | translate}}</button>
              </div>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-md-8 col-md-offset-1">
              <img class="img-responsive"
                   style="width:25%"
                   [src]="scannedImage"
                   *ngIf="scannedImage !='' && scannedImage != null" />
            </div>
          </div> -->
        </div>
        <div class="recipt-scanner-footer">
          <!-- <div class="row">
            <div class="col-md-11 col-md-offset-1">
              <div class="form-group">
                <button (click)="addCommercialInvoice()"
                        class="btn btn-primary"
                        style="float:right">Done</button>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
